import { loadStripe } from "@stripe/stripe-js";
import {
  isStripeLivePublishableKey,
  isStripeTestPublishableKey,
  STRIPE_PUBLISHABLE_KEY,
} from "../utils/env";

if (STRIPE_PUBLISHABLE_KEY) {
  const mode = isStripeLivePublishableKey()
    ? "live"
    : isStripeTestPublishableKey()
      ? "test"
      : "unknown";
  if (process.env.NODE_ENV === "development") {
    console.info(`[Stripe] Publishable key mode: ${mode}`);
  }
}

export const stripePromise = STRIPE_PUBLISHABLE_KEY
  ? loadStripe(STRIPE_PUBLISHABLE_KEY)
  : null;
